 <template>
  <v-container fluid>
    <h1>Component 1</h1>
    <ul>
      <li v-for="index in 100"
          :key="index"
          :style="'background-color: rgb(' + (255 - (index* 2.5)) + ', ' + (255 - (index* 2.5)) + ', ' + (255 - (index* 2.5)) + ');' ">
        {{index}}
      </li>
    </ul>
  </v-container>
</template>
 
 
 <script>
export default {
  name: "Component1",
  props: {},
  components: {},

  data() {
    return {};
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>
 
 
 <style lang='scss' scoped>
</style>